import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar/Sidebar'; 
import Thumbnail from '../../src/assets/images/work/business_trip/thumbnail.png';
import voiceDemo from '../../src/assets/video/business_trip.mp4';
import service from '../../src/assets/images/work/business_trip/service.png';
import overView from '../../src/assets/images/work/business_trip/overview.png';
import todoList from '../../src/assets/images/work/business_trip/todo_list.png';
import behaveScenario from '../../src/assets/images/work/business_trip/behave_scenario.png';
import itemEnumerate from '../../src/assets/images/work/business_trip/item_enumerate.png';
import screenTransition from '../../src/assets/images/work/business_trip/screen_transition.png';
import ability from '../../src/assets/images/work/business_trip/function.png';
import erd from '../../src/assets/images/work/business_trip/erd.png';
import point_1 from '../../src/assets/images/work/business_trip/point_1.png';
import point_2 from '../../src/assets/images/work/business_trip/point_2.png';
import point_3 from '../../src/assets/images/work/business_trip/point_3.png';
import visual from '../../src/assets/images/work/business_trip/visual.png';
import { ReactComponent as ExternalLinkIcon } from '../../src/assets/icons/external_link.svg';
import './raiden/raiden.css'; 
import './SinglePost.css';

function BusinessTrip() {
    // 見出し情報とアクティブな見出しを管理する状態
        const [headings, setHeadings] = useState([]);
        const [activeHeadingId, setActiveHeadingId] = useState(null);
    
        // コンテンツのDOMを参照するためのref
        const contentRef = useRef(null);
    
        // ① コンテンツを通常のJSXで記述
        const contentJSX = (
            <div>
                <div className="article-title-block">
                    <h1 className="article-title">出張申請サービス</h1>
                    <div className="article-sub-title"><strong>要件定義と情報設計で実現する、ユーザーに優しい業務アプリ設計</strong></div>
                </div>
                            
                <div className="article-info">
                    <div className="use-tool">
                        <div><strong>使用ツール：</strong>Figma</div>
                    </div>
                    <div className="product-period">
                    <div><strong>制作期間：</strong>4ヶ月</div>
                    </div>
                </div>
                
                <div className="thumbnail-block">
                    <div>
                        <img 
                            src={Thumbnail} 
                            alt="出張申請サービスのサムネイル画像です。" 
                        /> 
                    </div>  
                </div>

                <section className="overview">
                    <h2>概要</h2>
                    <div className="section-content">
                        <p>
                        本記事では、BONO(UI/UXが学べるコミュニティ)の課題として取り組んだ「オンラインで申請できる出張申請サービス」のデスクトップUIデザインについて紹介します。今回は特に、<strong>要件定義と情報設計に重点を置き</strong>、初めて出張申請を行うユーザーでも迷わず使える、<strong>アクセシビリティにも配慮した</strong>業務アプリを目指して設計を行いました。
                        </p>
                    </div>
                </section>

                <section className="prototype">
                    <h2>成果物</h2>
                    <div className="section-content">
                        <div className="video-container wide">
                            <figure>
                                <video controls aria-describedby="video-desc" className="test-video">
                                <source src={voiceDemo} type="video/mp4" />
                                お使いのブラウザは動画をサポートしていません。
                                </video>
                                <figcaption id="video-desc">
                                この動画では、出張申請サービスの新規作成から出張申請をするまでの流れを画面録画したデモを紹介しています。
                                </figcaption>
                            </figure>
                        </div>
                    </div>
                </section>


                <section>
                    <h2>サービスの全体像</h2>
                    <div className="section-content">
                        <p className="section-lead-text">本サービスは、出張に不慣れな社員や視覚特性がある社員でもストレスなく、オンラインで出張申請が完結できるサービスです。コロナにも対応しています。社員の申請フロー周りをメインに取り組みしました。</p>
                        <div className="ui-img"> 
                            <img 
                                src={service} 
                                alt="左側に紙の出張申請書、右側にコロナ関係書書類が表示されています。" 
                            />
                        </div>  
                        <div className="ui-img"> 
                            <img 
                                src={overView} 
                                alt="中央に出張申請サービスがあり、周りに利用者が表示されています。社員と出張申請サービスが赤い丸で囲まれています。" 
                            />
                        </div>  

                    <ul>
                        <p><strong>今回考慮しないこと/作成しないもの（今後の課題）</strong>
                        </p>
                        <li>管理者ページ。</li>
                        <li>社員のマイページ。</li>
                        <li>他サービスの利用。乗り換え案内の地図APIなど。選定や内容理解に時間がかかるため。</li>
                        
                    </ul>
                    </div>
                </section>




                <section className="use-case">
                    <h2>ペルソナ</h2>
                    <div className="section-content">
                        <ul>
                            <li><strong>出張が初めてのサラリーマン</strong></li>
                            <p>業務アプリに不慣れで、出張のルールや手順をよく知らない。</p>
                            <li><strong>視野が狭く、明度差に反応しづらい視覚特性があるサラリーマン</strong></li>
                            <p>視野が部分的に欠ける視野狭窄で、明るさの違いやコントラストの弱い配色が見分けにくい傾向がある。</p>
                        </ul>
                    </div>
                </section>

                <section className="purpose">
                    <h2>サービスの目的</h2>
                    <div className="section-content">
                        <ul>
                            <li>迷わず、スムーズに出張申請できること。</li>
                            <li>申請ミスやストレスを最小限にすること。</li>
                            <li>視覚特性を持つ方でも問題なく操作できるUIを実現すること。</li>
                        </ul>
                    </div>

                </section>



                <section>
                    <h2>実現したいこと</h2>
                    <div className="section-content">
                        <p className="section-lead-text">利用者別でやりたいことを洗い出しました。今回は申請フローを中心に制作をおこなったので、上長、経理は承認者として一括りにしています。また、「どんな状況で？どんな気持ちで？」を加えることで、ユーザーの隠れた課題やニーズを発見できるようにしました。</p>
                            <div className="ui-img"> 
                                <img 
                                    src={todoList} 
                                    alt="申請者と承認者別で実現したいことのリストが表示されています。" 
                                />
                            </div>  
                        
                    </div>

                </section>

                <section>
                    <h2>行動シナリオ</h2>
                    <div className="section-content">
                    <p className="section-lead-text">出張申請サービスにおいて、利用者がどのような行動を取るのかを時系列で整理しました。
この行動シナリオの作成方法と、次に行った要件定義の進め方については、羽生章洋さんの著書『はじめよう！要件定義 〜ビギナーからベテランまで』および、その内容を実践的に取り組まれていた金 成奎さんのnote記事を大変参考にさせていただきました。
ここから先は、これらの資料に基づいて進めています。
（参考文献は記事の最後にまとめています）</p>
                    <div className="list-block">
                        <p>行動シナリオを描く上で重要なのは、以下の４つを意識することだと書かれていました。</p>
                        <ul>
                            <li>仕事</li>
                            <li>成果</li>
                            <li>材料</li>
                            <li>きっかけ</li>
                        </ul>
                        <p><strong>仕事</strong>には<strong>成果</strong>が伴い、<strong>成果</strong>を出すための<strong>材料</strong>が必要です。そして、その仕事を行うためには<strong>トリガー・きっかけ（イベント）</strong>があります。</p>
                    </div>  
                    <p>これらを意識して作成した「出張申請書を新規作成する」行動シナリオが以下になります。（こちらも金成奎さんのnote記事の例にならい、<strong>きっかけ→赤、成果・材料→黄色、仕事→緑</strong>で表しています。）</p>  
                    <figure>
                            <img 
                                src={behaveScenario} 
                                alt="社員とソフトウェアがそれぞれのレーンで行うことが時系列で表示されています。" 
                            />     
                      
                        <figcaption>例：「出張申請書を新規作成する」行動シナリオの冒頭部分</figcaption>
                    </figure>
                    </div>
                    

                </section>


                <section>
                    <h2>要件定義</h2>
                    <div className="section-content">
                        <div className="list-block">
                            <p>本に従い、要件定義では、次の3つの要素を定めていきました。</p>
                            <ul>
                                <li>UI</li>
                                <li>機能</li>
                                <li>データ</li>
                            </ul>
                        </div>        
            
                        <div>
                            <h3>1.UIを考える</h3>
                                <p>まず、「UI・機能・データ」のうちの「UI」を決めていきます。主にUIを構成する（データ項目・操作項目・レイアウト）を考えていきました。</p>
                                <h4>ラフイメージから項目を書き出す</h4>
                                    <p>先ほどの行動シナリオから、ソフトウェアに対して仕事をしている部分を抜き出し、その「仕事」の画面イメージをラフ図として描き出しました。その後、その図を見ながら、必要なUIの項目を列挙していきました。</p>
                                    <div> 
                                        <figure>
                                            <img 
                                                src={itemEnumerate} 
                                                alt="左側にラフ図があり、右側に項目を列挙した表が書かれています。" 
                                            />
                                            <figcaption>例：出張申請の一覧を確認する</figcaption>
                                        </figure>    
                                    </div>  

                                <h4>画面遷移図を作成する</h4>
                                    <p>同時に、画面間の遷移も検討しました。項目を記載した画面同士を繋げながら、遷移のトリガーとなるイベントを赤色で示しました。</p>
                                    <figure>
                                        <img 
                                            src={screenTransition} 
                                            alt="画面同士を繋げた全体図が表示されています。" 
                                        />
                                        <figcaption>ざっくりとこんな感じの画面遷移図が描けました。</figcaption>
                                    </figure>
                            

                        </div>

                        <div>
                            <h3>2.機能を考える</h3>
                            <p className="section-lead-text">次は「UI・機能・データ」のうち、「機能」を考えます。「機能」とは、簡単に言えば「仕事」を意味します。そしてその仕事は、「入力」「処理」「出力」の3つの観点から捉えることができます。具体的には、先ほど作成した画面遷移図を見ながら、どの部分で機能が必要になるのかを一つずつ拾い上げていきました。また、機能に優先度をつけ、優先度の高いものからプロトタイプしていきました。</p>
                            <div className="ui-img"> 
                                    <figure>
                                        <img 
                                            src={ability} 
                                            alt="左側に検索機能、右側に出張申請機能が表示されており、それぞれ、「入力」「処理」「出力」の項目が書かれています。"
                                        />
                                        <figcaption>検索機能と出張申請機能の例</figcaption>

                                    </figure>
                                    
                            </div>  
                        </div>

                        <div>
                            <h3>3.データを考える</h3>
                            <p>最後に「UI・機能・データ」のうち、「データ」を考えます。UIと機能を定めたので、データの定義をしていきました。各機能で扱うデータをエンティティごとにまとめ、リレーションシップを設定していくことで、統合されたERDのようなものができました。これを行うことで、「データの流れ」や「つながり」を把握することができます。</p>
                            <div className="ui-img"> 
                                    <img 
                                        src={erd} 
                                        alt="データがエンティティごとにまとめられており、線で繋がれています。" 
                                    />
                            </div>  

                            <p>以上の「要件定義」（プロトタイプを含む）を何度も往復しながら、ときには実現したいことやユーザーの行動シナリオまで立ち返ることで、フローの不足や矛盾を見つけ出し、UI・機能・データの質を高めていきました。</p>
                        </div>
                    </div> 
                </section>



                <section className="point">
                    <h2>情報設計</h2>
                        <div className="section-content">
                            <div className="ui-point">
                                <h3>ステップ形式で段階的に進められる申請フロー</h3>
                                <h4>「迷いなく進める」ことで認知負荷を軽減する</h4>
                                <p  className="ui-description">
                                出張申請に不慣れなユーザーは、「どこから入力すればいいのか」がわからず戸惑いがちです。業務アプリでは項目が多く、1画面に情報が詰め込まれていると混乱を招きます。
                                そこで本サービスでは、<strong>申請フローを4ステップに分割し、1画面に対する情報量を絞る</strong>構成にし、ユーザーが目の前の操作に集中できるよう配慮しました。また、画面上部に
                                ステップナビを設け、「今どこにいるか」「あと何ステップあるか」が視覚的にわかるように設計しています。こうした構造は、<strong>初めて出張申請をするユーザーの不安を軽減し、
                                スムーズな申請体験につながる</strong>と考えています。
                                </p> 
                                <div className="ui-img"> 
                                    <img 
                                        src={point_1} 
                                        alt="申請画面が表示されています。" 
                                    />
                                </div> 
                            </div>    


                            <div className="ui-point">
                                <h3>誰にでも伝わるエラーメッセージ</h3>
                                <h4>「どこが間違っているかわからない」「エラーに気づけない」を防ぐ</h4>
                                <p>色覚特性を持つ方にとって、<strong>色のみで情報を伝えるUIは認識しにくい</strong>ことがあります。
                                そこでエラーメッセージは、<strong>色だけに頼らず注意アイコンを組み合わせて、視覚的な手がかりを複数用意</strong>しました。</p>
                                <p>また、<strong>エラーメッセージは入力欄のすぐ近くにテキストで表示</strong>することで、視線移動を最小限に抑え、エラーに気づきやすい構成としました。
                                このような設計は、視野が狭く一度に画面全体を見渡せないユーザーに有効です。重要な情報が分散せず、視野内に収まりやすいことで、<strong>ミスの発見や次の操作にスムーズにつながります。</strong></p>
                                <p>加えて、WCAG 2.1 レベルAA（4.5:1以上）のコントラスト比を基準に配色を設計することで、視覚特性のあるユーザーに限らず、<strong>誰もが一時的に見えづらい状況に置かれる可能性</strong>にも配慮した設計になっています。<strong>どんなユーザーが、どんな環境で操作していても、状態が確実に読み取れるUI</strong>を目指しました。</p>
                                
                                <div className="ui-img"> 
                                    <img 
                                        src={point_2} 
                                        alt="必須項目が入力されていない時のエラーメッセージが表示されています。" 
                                    />
                                </div> 
                            </div> 
                            <div className="ui-point">
                                <h3>処理結果が明確に伝わるフィードバック設計</h3>
                                <h4>「ちゃんとできたか不安」「動作したか分からない」を防ぐ</h4>
                                <p>ユーザーが操作を終えたあとに「ちゃんと送れたのか」「失敗したのか」がわからないUIは、不安や再操作の原因になります。
                                そこで、<strong>ファイルのアップロードや申請の送信などに対しては、処理結果に応じたメッセージを画面上に表示</strong>し、ユーザーが今の状態をすぐに把握できるように設計しました。成功・失敗・進行中といった<strong>操作の結果を即時にフィードバック</strong>することで、ユーザーの不安を取り除き、次の行動にスムーズにつなげられるよう意図しています。</p>

                                <div className="ui-img"> 
                                    <img 
                                        src={point_3} 
                                        alt="ファイルのアップロード画面で画面上部に「ファイルのアップロードが成功しました、」のメッセージが表示されています。" 
                                    />
                                </div> 
                            </div>      
                        </div>
                 </section>

                 <section class="overview">
                    <div>
                    <img 
                        src={visual} 
                        alt="出張申請サービスで作成した画面が並べられています。" 
                    />
    
                    </div>
    
                </section>
                
                
                <section className="summary">
                    <h2>学んだこと</h2>
                    <div className="section-content">
                        <p>今回の課題では、デザインだけでなく、要件定義から情報設計まで一貫して自分で考えるというプロセスに初めてしっかり取り組みました。特に要件定義では、「どんな機能が必要か」「どの画面で何ができるべきか」といった機能や情報の整理を徹底的に行い、それをもとに画面遷移図を作成しました。このプロセスを通して気づいたのは、デザイナーが要件定義まで関わることで、実装や運用を意識したUI設計ができるようになるということです。たとえば、「このボタンを押したらどの画面に遷移するのか」「データの流れはどうなるのか」といった視点が自然と芽生え、UIパーツの配置やラベル表記の説得力が増すと感じました。また、情報設計においても、事前に機能と画面の構造を整理しておいたことで、ユーザーにとって迷いの少ない導線や構成を考えやすくなりました。UIを作りながら「なぜここにこの情報が必要なのか」を説明できる状態になっていたことが、大きな収穫です。見た目を整えるだけではなく、裏側の仕組みやユーザーの行動を想像しながらUIを設計する力が身につきました。</p>
                    </div>
                </section>


                <section>
                    <div className="section-content">
                        <p>出張申請サービスのfigmaファイルは、以下のリンクからアクセスできます。</p>
                        <a  className="site-link"
                            href="https://www.figma.com/design/PZqP8jWpNxcAPvk0aT8q7k/%E5%87%BA%E5%BC%B5%E7%94%B3%E8%AB%8B?node-id=2649-6822&t=un71qR5LhNt3XXs0-1" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="出張申請のfigmaファイルを新しいタブで開きます"
                        >
                            出張申請サービスのfigmaファイル
                            <ExternalLinkIcon className="external-link-icon" />
                        </a>
                    </div>
                </section>
                
                                

                <section className="reference">
                    <h2>参考文献</h2>
                    <div className="section-content">
                        <div className="reference-block">
                        <div className="reference-type"><strong>書籍</strong></div>
                        <div className="reference-into">羽生章洋（2023）「はじめよう！要件定義 〜ビギナーからベテランまで」技術評論社</div>
                        <a  className="site-link note"
                            href="https://www.amazon.co.jp/%E3%81%AF%E3%81%98%E3%82%81%E3%82%88%E3%81%86-%E8%A6%81%E4%BB%B6%E5%AE%9A%E7%BE%A9-%E3%83%93%E3%82%AE%E3%83%8A%E3%83%BC%E3%81%8B%E3%82%89%E3%83%99%E3%83%86%E3%83%A9%E3%83%B3%E3%81%BE%E3%81%A7-%E7%BE%BD%E7%94%9F-%E7%AB%A0%E6%B4%8B/dp/4774172286/ref=sr_1_1?__mk_ja_JP=%E3%82%AB%E3%82%BF%E3%82%AB%E3%83%8A&crid=9I0OHS317SOV&dib=eyJ2IjoiMSJ9.S8IiZ453d0rRZnNknMOjTW4-BAvuGaWb2k4YWOsp5kN85D4fnmswsnG7LkOvfCCIC5TsC1qjG7gp3SJBWmfsdoDv5CxnKR-8q-nARvulTbLOMQVzhWH0Lr5ne_mk9EzMTG2Gahc_9WFdIl4bVXAwdXRRiUmdLxMsAkDurByJdvkYK1tyZdvCg9uRPdCT01IQ7ZdDhn8YUVNwTBMjL1glbbPQhKO3G6j-3rvDuqNK5Eo.jCAGga965bgVDt1ZFvsF3Rn1PdwCO9H61JZFTNIqXJg&dib_tag=se&keywords=%E3%80%8C%E3%81%AF%E3%81%98%E3%82%81%E3%82%88%E3%81%86%EF%BC%81%E8%A6%81%E4%BB%B6%E5%AE%9A%E7%BE%A9+%E3%80%9C%E3%83%93%E3%82%AE%E3%83%8A%E3%83%BC%E3%81%8B%E3%82%89%E3%83%99%E3%83%86%E3%83%A9%E3%83%B3%E3%81%BE%E3%81%A7%E3%80%8D&qid=1743890314&sprefix=%E3%81%AF%E3%81%98%E3%82%81%E3%82%88%E3%81%86+%E8%A6%81%E4%BB%B6%E5%AE%9A%E7%BE%A9+%E3%83%93%E3%82%AE%E3%83%8A%E3%83%BC%E3%81%8B%E3%82%89%E3%83%99%E3%83%86%E3%83%A9%E3%83%B3%E3%81%BE%E3%81%A7+%2Caps%2C165&sr=8-1" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="羽生章洋「はじめよう！要件定義 〜ビギナーからベテランまで」のAmazonを新しいタブで開きます"
                        >
                            Amazonで見る
                            <ExternalLinkIcon className="external-link-icon" />
                        </a>
                        </div>
                       
                        <div className="reference-block">
                        <div className="reference-type"><strong>webサイト</strong></div>
                        <div className="reference-into">note記事 金 成奎「『はじめよう！ 要件定義』（とそのシリーズ）を読んで、はじめよう！UIデザイン」</div>
                        <a  className="site-link note"
                            href="https://note.com/seikei_kin/n/n8d95535c0290" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="「金 成奎さんの『はじめよう！ 要件定義』（とそのシリーズ）を読んで、はじめよう！UIデザイン」」のnote記事を新しいタブで開きます"
                        >
                            noteで見る
                            <ExternalLinkIcon className="external-link-icon" />
                        </a>
                        </div>
                        
                    </div>
                </section>


            </div>

        );

        // ② コンテンツレンダリング後にrefから見出しを抽出する
      useEffect(() => {
        if (contentRef.current) {
          // querySelectorAllでh2, h3, h4タグを取得
          const headingEls = contentRef.current.querySelectorAll('h2, h3, h4');
          const extractedHeadings = [];
          headingEls.forEach((el, index) => {
            // IDがなければ自動で設定する
            if (!el.id) {
              el.id = `heading-auto-${index + 1}`;
            }
            // タグ名からレベルを数値として取得
            const level = parseInt(el.tagName.substring(1), 10);
            extractedHeadings.push({
              id: el.id,
              text: el.innerText,
              level: level,
            });
          });
          setHeadings(extractedHeadings);
        }
      }, []); // 一度だけ実行
    
      // ③ スクロールイベントでアクティブな見出しを更新（オプション）
      useEffect(() => {
        function handleScroll() {
          let currentActive = null;
          let minDistance = Infinity;
          headings.forEach(h => {
            const el = document.getElementById(h.id);
            if (el) {
              const rect = el.getBoundingClientRect();
              const distance = Math.abs(rect.top);
              if (distance < minDistance) {
                minDistance = distance;
                currentActive = h.id;
              }
            }
          });
          setActiveHeadingId(currentActive);
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }, [headings]);
    
      // ④ クリック時に対象の見出しへスクロールする処理
      const handleClickHeading = (headingId) => {
        const el = document.getElementById(headingId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
    
    
        return (
            <div className="single-post-container">
          
            <div className="single-post-main"> 
              <div className="back-to-home">
                <Link to="/" className="back-link">← Homeへ戻る</Link>
              </div>
    
              <div className="single-post-content" ref={contentRef}>
                {contentJSX}
              </div>
    
              <div className="back-to-home">
                <Link to="/" className="back-link">← Homeへ戻る</Link>
              </div>
            </div>
      
            <Sidebar
              headings={headings}
              activeHeadingId={activeHeadingId}
              onClickHeading={handleClickHeading}
            />
            
          </div>
    
        );
        

    
}
export default BusinessTrip;      